import React from "react";
import styled from "styled-components";
import {
  Span,
  Code,
  FullWrapper,
  DisplayHeading,
  Text,
  Box,
  RatioImage,
  Link
} from "./Primitives";
import { getRatio16to9 } from "../utils/getRatio16to9";
import { IoIosAddCircle } from "react-icons/io";
import { animated, Spring, interpolate } from "react-spring";
const SlideTag = styled(Text)`
  width: auto;
  position: absolute;
  top: 0;
  transform-origin: left top;
  transform: rotate(-90deg) translate(calc(-100% - 76px), calc(-100% - 8px));
  text-transform: uppercase;
  letter-spacing: 0.03rem;
  &:after {
    position: absolute;
    bottom: calc(50% - 1px);
    left: 100%;
    content: '';
    display: inline-block
    border-bottom: 1px solid grey;
    // width = left - margin-left;
    width: 72px;
    margin-left: 4px;
  }
`;
const SlideWrapper = styled(FullWrapper)`
  &:last-of-type {
    border-bottom: none;
  }
`;
const eleWidth = getRatio16to9(100);
const eleHeight = getRatio16to9(eleWidth);
const elePadLeft = getRatio16to9(eleHeight);
const HoverPanel = ({ bgOpacity, scale, rotation, ...props }) => (
  <animated.div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: bgOpacity.interpolate(op => `rgba(1,22, 39, ${op})`)
    }}
  >
    <animated.div
      style={{
        color: "white",
        backgroundColor: "rgba(1,22, 39, 1)",
        transformOrigin: "center",
        borderRadius: "50%",
        transform: interpolate(
          [rotation, scale],
          (r, s) => `scale(${s}) rotate(${r}deg)`
        )
      }}
    >
      <IoIosAddCircle
        style={{
          width: "125px",
          height: "125px"
        }}
      />
    </animated.div>
  </animated.div>
);
export class Slide extends React.Component {
  state = { isHovered: false };
  onHoverEnter = () => {
    this.setState({
      isHovered: true
    });
  };
  onHoverLeave = () => {
    this.setState({
      isHovered: false
    });
  };
  onClick = () => {
    if (this.props.id && this.props.history)
      this.props.history.push(`/project/${this.props.id}`);
  };
  render() {
    const { isHovered } = this.state;
    const { cover, id, title, description, color, library, tag } = this.props;
    return (
      <SlideWrapper
        alignItems="center"
        justifyContent={["center"]}
        flexDirection={["column", "row"]}
        borderBottom={[1]}
        borderColor="lines"
      >
        <Box
          width={["100%", "50%", 1 / 2, `${eleWidth}vh`]}
          height={["auto", "auto", "auto", `${eleHeight}vh`]}
          css={{
            flexShrink: "0"
          }}
          pl={[0, 3, 6, `${elePadLeft}vh`]}
          pt={[0, 0, "3"]}
          mb={[5, 0]}
          mr={[0, 2, 6]}
        >
          <Code color="accentPurple">
            Import <Span color="white">{library.import}</Span> from{" "}
            <Span color="white">"</Span>
            <Span color="mustard">{library.npm}</Span>
            <Span color="white">"</Span>;
          </Code>
          <DisplayHeading color={color} lineHeight={"1em"}>
            {title}
          </DisplayHeading>
          <Text
            pl={[2, 2, 3, 5]}
            py={[2]}
            mb={1}
            css={{
              borderLeft: "1px solid #7E97AC"
            }}
          >
            {description}
          </Text>
          <Link
            to={`/project/${id}`}
            p={[2, 2, 3]}
            onMouseEnter={this.onHoverEnter}
            onMouseLeave={this.onHoverLeave}
          >
            <Span color={color} borderBottom={1} borderColor={color}>
              Read More
            </Span>
          </Link>
        </Box>
        <RatioImage
          ratio={[1, 1, 1, 9 / 16]}
          width={["50%", "100%"]}
          mr={[0, 5]}
          display={["none", "block"]}
          bg="accentBlue"
          src={cover.src}
          alt={cover.alt}
          onMouseEnter={this.onHoverEnter}
          onMouseLeave={this.onHoverLeave}
          onClick={this.onClick}
          css={{ "&:hover": { cursor: "pointer" } }}
        >
          <SlideTag
            display={["none", "none", "block"]}
            color="white"
            fontSize={0}
            fontWeight={2}
            fontFamily="proxima"
          >
            {tag}
          </SlideTag>
          <Spring
            native
            to={
              isHovered
                ? { bgOpacity: 0.5, rotation: 360, scale: 1 }
                : { bgOpacity: 0, rotation: 0, scale: 0 }
            }
          >
            {props => <HoverPanel {...props} />}
          </Spring>
        </RatioImage>
      </SlideWrapper>
    );
  }
}

Slide.defaultProps = {
  color: "accentBlue",
  title: "Loremium Ipsu ame",
  id: "Loremium-Ipsu-ame",
  description:
    "Experiments with complex multi-layered animations and route transitions.",
  tag: "self-Initiated",
  library: { npm: "react", import: "React" },
  cover: { src: "", alt: "" }
};
